<template>
    <div>
        <div class="d-flex justify-content-center mb-3">
            <ul class="nav nav-pills">
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="aba == 'visao' ? 'active' : ''" @click.prevent="abrir('visao')">
                        Visão Geral
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="aba == 'lista' ? 'active' : ''" @click.prevent="abrir('lista')">
                        Autorizações
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="aba == 'info' ? 'active' : ''" @click.prevent="abrir('info')">
                        Informações
                    </a>
                </li>
            </ul>
        </div>

        <visao-geral-autoriz v-if="aba == 'visao'" />
        <solicitacao-autorizacao v-if="aba == 'lista'" />
        <informacoes v-if="aba == 'info'" />
        
    </div>
</template>

<script>
import VisaoGeralAutoriz from './VisaoGeralAutoriz.vue';
import SolicitacaoAutorizacao from './SolicitacaoAutorizacao.vue';
import Informacoes from '../callcenter/Informacoes.vue';

export default {
    data() { 
        return { 
            fluxo: null, 
        };
    },

    components: { 
        VisaoGeralAutoriz,
        SolicitacaoAutorizacao, 
        Informacoes
    }, 

    props: ['aba'], 

    methods: { 
        estado(fluxo) { 
            this.fluxo = fluxo;
        },

        abrir(aba) { 
            if ( aba != this.aba ) { 
              this.$router.push({ path: '/autorizacoes/' + aba });
            }
        },
    },
}
</script>